module.exports = __webpack_public_path__ + "img/paris.21e6b5bb.jpg";